// state
const state = {
  items: [],
  infoitem: [],
  checkoutStatus: null
}

// getters
const getters = {
  cartProducts: (state, getters, rootState) => {
    return state.items
  },
  cartInfoProduct: (state, getters, rootState) => {
    return state.infoitem
  },

  cartTotalPrice: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      return total + product.price * product.quantity
    }, 0)
  },
  cartTotalItems: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      return total + product.quantity
    }, 0)
  }
}

// actions
const actions = {
  checkout({ commit, state }, products) {
    const savedCartItems = [...state.items]
    commit('setCheckoutStatus', null)
    // empty cart
    commit('setCartItems', { items: [] })
    /* shop.buyProducts(
      products,
      () => commit('setCheckoutStatus', 'successful'),
      () => {
        commit('setCheckoutStatus', 'failed')
        // rollback to the cart saved before sending the request
        commit('setCartItems', { items: savedCartItems })
      }
    ) */
  },
  clearInfoItem({ commit, state }, products) {
    commit('setInfoItem', { item: [] })
  },
  delItem({ commit }, id) {
    commit('delItem', { id })
  },
  qtySet({ commit }, payload) {
    commit('qtySet', payload)
  },

  addProductToCartWithQty({ state, commit }, payload) {
    commit('setCheckoutStatus', null)
    const cartItem = state.items.find((item) => item.id === payload.product.id)
    if (!cartItem) {
      commit('pushProductToCart', {
        id: payload.product.id,
        name: payload.product.name,
        image: payload.product.main_image,
        price: payload.product.price,
        slug: payload.product.slug,
        qty: payload.qty
      })
    } else {
      commit('mergeItemQuantity', { id: payload.product.id, qty: payload.qty })
    }
  },
  addProductToCart({ state, commit }, product) {
    commit('setCheckoutStatus', null)
    const cartItem = state.items.find((item) => item.id === product.id)
    if (!cartItem) {
      commit('pushProductToCart', {
        id: product.id,
        name: product.nombre,
        image: product.main_image,
        price: product.precio,
        ref: `${product.ref}, Ref: ${product.referencia}`,
        slug: product.slug,
        qty: 1
      })
    } else {
      commit('incrementItemQuantity', cartItem)
    }
  },
  addProductToInfoItem({ state, commit }, product) {
    commit('pushProductToInfoItem', {
      id: product.id,
      name: product.nombre,
      image: product.main_image,
      price: product.precio,
      ref: `${product.modelomoto_with_marcamoto.marcamoto.descripcion} - ${product.modelomoto_with_marcamoto.descripcion}, Ref: ${product.referencia}`,
      slug: product.slug,
      qty: 1
    })
  }
}

// mutations
const mutations = {
  pushProductToCart(state, { id, name, image, price, ref, slug, qty }) {
    state.items.push({
      id,
      image: image,
      name: name,
      price: price,
      ref: ref,
      slug: slug,
      quantity: qty
    })
  },
  pushProductToInfoItem(state, { id, name, image, price, ref, slug, qty }) {
    state.infoitem = []
    state.infoitem.push({
      id,
      image: image,
      name: name,
      price: price,
      ref: ref,
      slug: slug,
      quantity: qty
    })
  },

  incrementItemQuantity(state, { id }) {
    const cartItem = state.items.find((item) => item.id === id)
    cartItem.quantity++
  },
  mergeItemQuantity(state, { id, qty }) {
    const cartItem = state.items.find((item) => item.id === id)
    cartItem.quantity = Number(cartItem.quantity) + Number(qty)
  },
  qtySet(state, payload) {
    const cartItem = state.items.find((item) => item.id === payload.id)
    cartItem.quantity = payload.qty
  },
  delItem(state, { id }) {
    const cartItem = state.items.find((item) => item.id === id)
    state.items = state.items.filter(function(obj) {
      return obj.id !== id
    })
  },

  setCartItems(state, { items }) {
    state.items = items
  },
  setInfoItem(state, { item }) {
    state.infoitem = item
  },

  setCheckoutStatus(state, status) {
    state.checkoutStatus = status
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
